import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

function AddMetaTags({ onMetaTagAdded, editMeta }) {
  const validationSchema = Yup.object({
    siteName: Yup.string().trim().required("Site Name is required"),
    metaTitle: Yup.string().trim().required("Meta Title is required"),
    metaDescription: Yup.string().trim().required("Meta Description is required"),
    metaKeywords: Yup.string().trim().required("Meta Keywords are required"),
    metaImage: Yup.string().trim().required("Meta Image is required"),
  });

  const formik = useFormik({
    initialValues: {
      siteName: "",
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      metaImage: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const data = {
        site_name: values.siteName.trim(),
        meta_title: values.metaTitle.trim(),
        meta_desc: values.metaDescription.trim(),
        meta_key: values.metaKeywords.trim(),
        meta_image: values.metaImage.trim(),
      };

      try {
        await axios.post("https://api.plusdistribution.in/meta/add-meta", data);
        onMetaTagAdded(data);
        resetForm();
      } catch (error) {
        console.error("Error adding meta tag:", error);
      }
    },
  });

  useEffect(() => {
    if (editMeta) {
      formik.setValues({
        siteName: editMeta.site_name || "",
        metaTitle: editMeta.meta_title || "",
        metaDescription: editMeta.meta_desc || "",
        metaKeywords: editMeta.meta_key || "",
        metaImage: editMeta.meta_image || "",
      });
    }
  }, [editMeta]);

  return (
    <div>
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
        <div className="form-group">
          <input
            type="text"
            id="site-name"
            name="siteName"
            placeholder="Enter the site name"
            value={formik.values.siteName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`border-[#025066] border bg-white rounded-md py-[14px] px-[14px] w-full text-black text-[14px] font-medium leading-[142.857%] outline-none ${formik.touched.siteName && formik.errors.siteName ? 'error' : ''}`}
          />
          {formik.touched.siteName && formik.errors.siteName ? (
            <div className="error-message">{formik.errors.siteName}</div>
          ) : null}
        </div>

        <div className="form-group">
          <input
            type="text"
            id="meta-title"
            name="metaTitle"
            placeholder="Enter the meta title"
            value={formik.values.metaTitle}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`border-[#025066] border bg-white rounded-md py-[14px] px-[14px] w-full text-black text-[14px] font-medium leading-[142.857%] outline-none ${formik.touched.metaTitle && formik.errors.metaTitle ? 'error' : ''}`}
          />
          {formik.touched.metaTitle && formik.errors.metaTitle ? (
            <div className="error-message">{formik.errors.metaTitle}</div>
          ) : null}
        </div>

        <div className="form-group">
          <textarea
            rows={1}
            id="meta-description"
            name="metaDescription"
            placeholder="Enter the meta description"
            value={formik.values.metaDescription}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`border-[#025066] border bg-white rounded-md py-[14px] px-[14px] w-full text-black text-[14px] font-medium leading-[142.857%] outline-none ${formik.touched.metaDescription && formik.errors.metaDescription ? 'error' : ''}`}
          />
          {formik.touched.metaDescription && formik.errors.metaDescription ? (
            <div className="error-message">{formik.errors.metaDescription}</div>
          ) : null}
        </div>

        <div className="form-group">
          <input
            type="text"
            id="meta-keywords"
            name="metaKeywords"
            placeholder="Enter meta keywords (comma-separated)"
            value={formik.values.metaKeywords}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`border-[#025066] border bg-white rounded-md py-[14px] px-[14px] w-full text-black text-[14px] font-medium leading-[142.857%] outline-none ${formik.touched.metaKeywords && formik.errors.metaKeywords ? 'error' : ''}`}
          />
          {formik.touched.metaKeywords && formik.errors.metaKeywords ? (
            <div className="error-message">{formik.errors.metaKeywords}</div>
          ) : null}
        </div>

        <div className="form-group">
          <input
            type="text"
            id="meta-image"
            name="metaImage"
            placeholder="Enter the meta image URL"
            value={formik.values.metaImage}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`border-[#025066] border bg-white rounded-md py-[14px] px-[14px] w-full text-black text-[14px] font-medium leading-[142.857%] outline-none ${formik.touched.metaImage && formik.errors.metaImage ? 'error' : ''}`}
          />
          {formik.touched.metaImage && formik.errors.metaImage ? (
            <div className="error-message">{formik.errors.metaImage}</div>
          ) : null}
        </div>

        <button type="submit" className="submit-btn bg-[#025066] hover:scale-95 transition-all duration-300 ease-linear rounded-md text-white text-[16px] font-semibold py-[14px]">
          {editMeta ? 'Update Meta Tag' : 'Add Meta Tag'}
        </button>
      </form>
    </div>
  );
}

export default AddMetaTags;
